
import { Message, MessageBox } from 'element-ui';

var messageUtils = {
    success(text = '操作成功！') {
        Message({
            message: text,
            type: 'success',
            duration: 2000
        });
    },

    error(text = '操作失败！') {
        Message({
            message: text,
            type: 'error',
            duration: 2000
        });
    },

    info(text = '操作成功！') {
        Message({
            message: text,
            type: 'info',
            duration: 2000
        });
    },

    warning(text = '警告提示！') {
        Message({
            message: text,
            type: 'warning',
            duration: 2000
        });
    },

    confirm(text) {
        return new Promise((resolve, reject) => {
            MessageBox.confirm(text, '系统提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                resolve(true);
            }).catch(() => {
                Message.warning('已取消');
                reject(false);
            });
        }).catch(() => { });
    },
    delConfirm(text,iconClass) {
        return new Promise((resolve, reject) => {
            MessageBox.confirm(text, '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                iconClass:iconClass,
                center: true,
                dangerouslyUseHTMLString: true
            }).then(() => {
                resolve(true);
            }).catch(() => {
                Message.warning('已取消');
                reject(false);
            });
        }).catch(() => { });
    }
}

export default messageUtils;